export default "__VITE_ASSET__9bOdXKL3__"